<template>
  <block-title
    class="transport overview"
    :show-line="false"
    title="运费占比"
  >
    <div slot="icon-right" class="block-icon-right" >
      <a-radio-group
        v-model="selectTime"
        button-style="solid"
        class="order-time"
        size="small"
      >
        <a-radio-button
          v-for="item in timeList"
          :key="item.value"
          :value="item.value"
          @click="getOverview(item.value)"
        >
          {{item.label}}
        </a-radio-button>
      </a-radio-group>
      <a-range-picker v-model="dateTime" @change="changePicker">
        <template #suffixIcon>
          <a-icon type="calendar" />
        </template>
      </a-range-picker>
    </div>
    <p class="tips">
      <!-- <img src="@/assets/img/icon_notic.png" alt=""> -->
      <a-icon type="exclamation-circle" />
      本运费为系统预估，实际运费以稽核后为准
    </p>
    <div class="EchartBox">
      <div id="main"></div>
    </div>
  </block-title>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import * as echarts from 'echarts';
import moment from 'moment'
import base from '@/api/base'
import { transportCost } from '../api'
import {transportData} from '../constant';

export default {
  name: 'Transport',
  components: {
    BlockTitle
  },
  props: {
    isDemo: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      myChart: null,
      selectTime: '0',
      dateTime: [moment().startOf('day'), moment().endOf('day')],
      timeList: [
        {
          label: '今天',
          value: '0'
        },
        {
          label: '近7天',
          value: '7'
        },
        {
          label: '近30天',
          value: '30'
        }
      ],
      option: null
    }
  },
  created(){
    this.getData()
  },
  mounted(){
    window.addEventListener('resize', ()=>{
      this.resize()
    })
  },
  methods: {
    changePicker(val) {
      this.selectTime = val?.length ? '' : '0'
      this.getData()
    },
    getData(){
      if (this.isDemo) {
        this.$nextTick(async() => {
          const res = await base.getDictionary({
            status: 1,
            type: 'board_freight_ratio'
          })
          const data = {};
          let total = 0
          res.forEach(item => {
            if (transportData[item.dictionaryName]) {
              total += Number(item.dictionaryCode || 0)
              data[transportData[item.dictionaryName]] = item.dictionaryCode || 0
            }
          });
          data.total_amt = total
          this.init([data])
        })
        return
      }
       const {projectIds,creditCode,customers,customerCode}=this.$store.state.user
       const data={
         startTime: moment(this.dateTime[0]).format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment(this.dateTime[1]).format('YYYY-MM-DD HH:mm:ss')
       }
       if(creditCode){
         data.customerCodes=customers.map(item=>item.customerCode)
         data.projectIds=projectIds
       }else{
         data.customerCode=customerCode
         data.projectIds=projectIds
       }
      transportCost(data).then((res) => {
        this.init(res)
      })
    },
    getOverview(value) {
      const endTime = moment().endOf('day')
      let startTime = ''
      switch(value) {
        case '7':
          startTime = moment().subtract(6, "days").startOf('day')
          break
        case '30':
          startTime = moment().subtract(29, "days").startOf('day')
          break
        default:
          startTime = moment().startOf('day')
          break
      }
      this.$set(this,'dateTime',[startTime, endTime])
      this.getData()
    },
    init(res){
      const data = res[0]
      const chartDom = document.getElementById('main');
      this.myChart = echarts.init(chartDom);
      const dataList = [
        { value: data.zhuanche_amt, name: '专车', itemStyle: { color: '#37C598' } },
        { value: data.lingdan_amt, name: '零担', itemStyle: { color: '#E77676' } },
        { value: data.quyupei_amt, name: '区域配', itemStyle: { color: '#EDB279' } },
        { value: data.dianweipei_amt, name: '点位配', itemStyle: { color: '#9FCC76' } },
        { value: data.yidanyiyi_amt, name: '一单一议', itemStyle: { color: '#8888DF' } },
        { value: data.huoyun_amt, name: '货运', itemStyle: { color: '#4F97E5' } }
      ]
      const totalNumber = data.total_amt
      this.option = {
        title: [
          {
            text: '运费金额合计',
            left: '28%',
            top: '46%',
            textAlign: 'center',
            textStyle: {
              color: '#909399',
              fontWeight: 'normal',
              fontSize: 18,
            },
          },
          {
            subtext: `￥${totalNumber}`,
            left: '28%',
            top: '51%',
            textAlign: 'center',
            subtextStyle: {
              color: '#171717',
              fontWeight: 'bold',
              fontSize: 24,
            }
          }
        ],
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return `<div>
                <p>${params.seriesName}</p>
                <span style="display: inline-block;width:10px;height:10px;background:${params.color};border-radius: 50%;"></span>
                <span>${params.name}</span>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;￥${params.value}</span>
              </div>`
          },
        },
        legend: {
          right: 20,
          orient: 'vertical',
          top: '16%',
          bottom: 20,
          padding: [5, 5],
          itemHeight: 12,
          itemWidth: 20,
          itemGap: 30,
          formatter (name) {
            const item = dataList.filter((e) => {
              return e.name === name
            })
            if(item.length > 0){
              const len = item[0].name.length
              const arr = []
              for(let i = 0; i<= 16-len*3; i+=1){
                arr.push(' ')
              }
              const num = item[0].value && totalNumber ? (item[0].value / totalNumber * 100).toFixed(2) : 0
              return `${item[0].name}${arr.join('')}${num}%     ￥${item[0].value}`;
            }
            return `${name}`;
          }
        },
        series: [
          {
            name: '运费占比',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['28%', '55%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 6,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: '40',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: dataList
          }
        ]
      };
      this.windowWidth()
      this.myChart.setOption(this.option);
    },
    resize(){
      this.windowWidth()
      this.myChart.setOption(this.option);
      this.myChart.resize()
    },
    windowWidth(){
      if(window.innerWidth < 1600){
        this.option.legend.orient = 'horizontal'
        this.option.legend.top = '84%'
        this.option.series[0].center = ['35%', '50%']
        this.option.series[0].radius = ['40%', '60%']
        this.option.title[0].left = '33%'
        this.option.title[0].top = '44%'
        this.option.title[1].left = '33%'
        this.option.title[1].top = '49%'
        this.option.legend.itemGap = 10
      } else {
        this.option.legend.orient = 'vertical'
        this.option.legend.top = '23%'
        this.option.series[0].center = ['28%', '55%']
        this.option.series[0].radius = ['40%', '70%']
        this.option.title[0].left = '28%'
        this.option.title[0].top = '46%'
        this.option.title[1].left = '28%'
        this.option.title[1].top = '51%'
        this.option.legend.itemGap = 32
      }
    }
  }
}
</script>

<style lang="less" scoped>
.transport{
  height: calc(100% - 15px);
  position: relative;
  /deep/ .label{
    position: absolute;
    width: 100%;
  }
  .tips{
    position: absolute;
    left: 32px;
    top: 70px;
    z-index: 20;
    color: #909399;
    font-size: 14px;
  }
  .EchartBox{
    padding: 8px 32px 12px 32px;
    width: 100%;
    height: 100%;
    // height: calc(100% - 44px);
    margin-top: 30px;
    #main{
      width: 100%;
      height: 100%;
    }
  }
  .order-time{
    margin-right: 12px;
  }
  /deep/ .ant-calendar-picker-input{
    width: 180px !important;
  }
}
</style>